<template>
  <div>
    <section>
      <v-container grid-list-xl>
          <v-divider></v-divider>
        <v-layout row wrap justify-center class="my-4">
          <v-flex xs12 sm4>
            <v-card flat class="transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="title font-weight-bold">サービス提供者</div>
              </v-card-title>
              <v-card-text>
                <a href="https://www.ksk.co.jp/" target="_blank">株式会社KSK</a>システムソリューション事業本部 AI推進室
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 offset-sm1>
            <v-card flat class="transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="title font-weight-bold">お問い合わせ</div>
              </v-card-title>
              <p
                class="body-2 gray--text text--lighten-3"
              >サービス利用開始の通知をご希望の方、サービスに対するご質問、お打ち合わせをご希望の方は、以下よりお願いいたします。</p>

              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-action>
                    <v-icon class="blue--text text--lighten-2">mdi-phone</v-icon>
                  </v-list-item-action>
                  <p>
                    <v-list-item-title class="body-2">050-3803-8150（AI推進室・RPA担当）</v-list-item-title>
                  </p>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon class="blue--text text--lighten-2">mdi-email</v-icon>
                  </v-list-item-action>
                  <p>
                    <v-list-item-title  class="body-2"><a href="mailto:rpadash@ksk.co.jp?subject=RPAダッシュ！に関する問い合わせ&amp;body=＊以下をご記入いただき、お送りくださいませ。%0d%0a貴社名：%0d%0aお名前：%0d%0aご用件：%0d%0a%0d%0a株式会社KSK（システムソリューション事業本部：AI推進室・RPA担当）">rpadash@ksk.co.jp</a></v-list-item-title>
                  </p>
                </v-list-item>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
